import Repository from '@/repositories/marketing'
const resource = '/secure_lists'

export default {
    get(config){
        return Repository.get(`${resource}.json`, config)
    },
    refreshCount(id,config){
        return Repository.get(`${resource}/${id}/refresh_count.json`, config)
    },
    export(id,config){
        return Repository.get(`${resource}/${id}/export.json`, config)
    },
    csvImport(id,config){
        return Repository.post(`${resource}/${id}/csv_import.json`, config)  
    },
    ftpImport(id,config){
        return Repository.post(`${resource}/${id}/ftp_import.json`, config)  
    },
    create(config){
        return Repository.post(`${resource}.json`, config)
    },
    update(id,config){
        return Repository.put(`${resource}/${id}.json`, config)
    },
    getSingle(id,config){
        return Repository.get(`${resource}/${id}.json`, config)
    },
    delete(payload){
        return Repository.delete(`${resource}/bulk_delete.json`,payload)
    },
    bulkRefresh(config) {
        return Repository.post(`${resource}/bulk_refresh.json`, config)
    },
}